import { createSelector } from 'reselect';

const getUserManager = ({ portal }) => {
    return portal.userManager;
};

export const getUser = ({ overview }) => {
    return overview.user.data;
};

const getUserCapabilitiesLoadingStatus = ({ overview }) => {
    return overview?.userCapabilities?.loadingStatus;
};

const getSelectedGeneralFilter = ({ generalFilter }) => {
    return generalFilter?.selectedFilters;
};

const getReportIssueState = ({ overview }) => overview.reportIssueDialog || {};
// Basic selectors
const getReportIssueVisibility = (state) => getReportIssueState(state).isVisible || false;
const getReportIssueModalType = (state) => getReportIssueState(state).modalType;
const getReportIssueModalMetadata = (state) => getReportIssueState(state).modalMetadata || {};

export const getModel = createSelector([
    getUserManager,
    getUser,
    getUserCapabilitiesLoadingStatus,
    getSelectedGeneralFilter,
    getReportIssueVisibility,
    getReportIssueModalType,
    getReportIssueModalMetadata
], (
    userManager,
    user,
    userCapabilitiesLoadingStatus,
    selectedGeneralFilter,
    reportIssueVisibility,
    reportIssueModalType,
    reportIssueModalMetadata
) => {
    return {
        userManager,
        user,
        userCapabilitiesLoadingStatus,
        selectedGeneralFilter,
        reportIssueVisibility,
        reportIssueModalType,
        reportIssueModalMetadata
    };
});
